import { storeData } from './data/storeData';
import metaData from './block.json';
import Edit from './edit';
import ErrorBoundary from './components/errorBoundary';
import FrontendDisplay from './frontend';

/**
 * Initializes the block, registers it, and renders the frontend display.
 *
 * @param { Object } blocks
 */
( function( blocks ) {
	const registerBlockType = blocks.registerBlockType;

	// Register the block
	registerBlockType( metaData.name, {
		title: metaData.title,
		icon: metaData.icon,
		category: metaData.category,
		edit: Edit,
		save: ( ) => {
			return null;
		},
	} );

	// Frontend display
	document.addEventListener( 'DOMContentLoaded', async () => {
		const containers = document.querySelectorAll( '[data-react-app="product-lookup"]' );
		await Promise.all( Array.from( containers ).map( async container => {
			const countryCode = container.getAttribute( 'data-country-code' );
			await storeData( countryCode );
			const productsPerPage = parseInt( container.getAttribute( 'data-products-per-page' ), 10 );
			const root = wp.element.createRoot( container );
			root.render(
				<ErrorBoundary>
					<FrontendDisplay productsPerPage={ productsPerPage } countryCode={ countryCode } />
				</ErrorBoundary>
			);
		} ) );
	} );
}( window.wp.blocks, window.wp.element ) );
